import React,{useEffect} from 'react';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';
import { useSelector } from 'react-redux';
export const Header = ({ onMenuClick }) => {
      const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  
  const { user, branchLock, logout } = useAuth();
  const {
    syncing,
    syncStatus,
    lastSyncTime,
    currentBranchFilter,
    setCurrentBranchFilter,
    syncWithGoogleSheets,
    allStudentsData
  } = useData();

  const schools = [ ...new Set( allStudentsData .map(s => s.school).filter(school => school.trim() == items?.schoolName.trim() ))].sort();
  // .filter(Boolean)
// console.log("allStudentsData",allStudentsData);
  const getHeaderTitle = () => {
    if (branchLock) {
      const branchName = branchLock.split(',')[1] ? branchLock.split(',')[1].trim() : branchLock;
      return `${branchName}`;
      // State School, 
    }
    if (currentBranchFilter !== 'all') {
      const branchName = currentBranchFilter.split(',')[1] ? currentBranchFilter.split(',')[1].trim() : currentBranchFilter;
      return `${branchName}`;
      // State School, 
    }
    return 'State Schools';
  };

  const getSubtitle = () => {
    if (branchLock || currentBranchFilter !== 'all') {
      return `${SelectDate?.display} Diagnostic Performance Dashboard · Grade ${JSON.parse(localStorage.getItem("AGrades"))?.join(",")}`;
    }
    return `${SelectDate?.display} Diagnostic Performance Dashboard — ${schools?.length} Branches · Grade ${JSON.parse(localStorage.getItem("AGrades"))?.join(",")}`;
  };
useEffect(()=>{
  // syncWithGoogleSheets();
},[])
  return (
    <div className="fixed left-0 right-0 dflex flexd-column alignitems JCCenter" style={{color:"#00009A",fontWeight:"700",backgroundColor:"#FFF",zIndex:"100"}}>
      {items?.userTypeId !== 2 &&<span>{getHeaderTitle()}</span>}
      <span>{getSubtitle()}</span>
    </div>
    // <header
    //   className="fixed left-0 right-0 h-20 z-30 shadow-lg select-none"
    //   // style={{ backgroundColor: '#347363' }}
    // >
    //   <div className="h-full px-4 sm:px-8 flex justify-between items-center">
    //     {/* Left: Hamburger & Logo */}
    //     <div className="flex items-center space-x-2 sm:space-x-4 shrink-0">
    //       <button
    //         onClick={onMenuClick}
    //         title="Menu"
    //         className="lg:hidden p-2 -ml-1 text-white rounded-lg hover:bg-white/10 transition-colors shrink-0 cursor-pointer"
    //       >
    //         <span className="text-2xl leading-none">☰</span>
    //       </button>
    //       {/* <img
    //         src="https://www.northsouth.org/wp-content/uploads/2024/09/nsf-logov1.png"
    //         alt="School Logo"
    //         className="h-14 w-auto rounded-lg shadow-md bg-white p-1 shrink-0"
    //         onError={(e) => { e.target.src = 'https://placehold.co/100x100?text=LOGO'; }}
    //       /> */}
    //     </div>

    //     {/* Center: Title & Subtitle */}
    //     <div className="text-center min-w-0 px-2">
    //       <h1 className="text-lg sm:text-2xl font-bold text-white leading-tight truncate">
    //         {/* {getHeaderTitle()} */}
    //       </h1>
    //       <div className="hidden sm:flex items-center justify-center gap-2 flex-wrap mt-0.5">
    //         <p className="text-xs text-white/80 font-medium tracking-wide" style={{ color:"black" }}>
    //           {getSubtitle()}
    //         </p>
    //         {/* <span className="text-white/25 text-xs" aria-hidden="true">|</span>
    //         <span className="inline-flex items-center gap-1.5 text-[11px] bg-white/15 text-white px-2.5 py-1 rounded-full font-semibold tracking-wide border border-white/15 shadow-sm">
    //           {syncStatus === 'syncing' ? '🔄 Synchronizing...' : syncStatus === 'failed' ? '❌ Sync Failed' : 'Cloud Sync Ready'}
    //         </span>
    //         <span className="text-[10px] text-white/60 font-medium">
    //           {lastSyncTime ? `Last sync: ${lastSyncTime}` : 'Never synced'}
    //         </span> */}
    //       </div>
    //     </div>

    //     {/* Right: Controls & User Profile */}
    //     <div className="flex items-center space-x-2 md:space-x-3 shrink-0">
    //       {/* Branch scope dropdown or badge */}
    //       {/* <div className="flex items-center gap-1.5">
    //         <span className="text-white text-lg hidden xl:inline" title="Branch">🏫</span>
    //         {branchLock ? (
    //           <span className="px-3 py-2 rounded-lg text-xs font-bold bg-white/15 text-white border border-white/20 whitespace-nowrap">
    //             {branchLock}
    //           </span>
    //         ) : (
    //           <select
    //             value={currentBranchFilter}
    //             // onChange={(e) => setCurrentBranchFilter(e.target.value)}
    //             // onChange={(e) => console.log(e.target.value)}
    //             className="px-2 py-2 rounded-lg text-xs font-bold bg-white/10 hover:bg-white/20 text-white border border-white/20 outline-none cursor-pointer max-w-[6rem] md:max-w-[9rem]"
    //           >
    //             {/* <option value="all" className="text-gray-800">All Branches</option> *
    //             {schools.map(s => (
    //               <option key={s} value={s} className="text-gray-800">
    //                 {s}
    //               </option>
    //             ))}

    //             {/* {schools.map(s => (
    //               <option key={s} value={s} className="text-gray-800">
    //                 {s}
    //               </option>
    //             ))} *
    //           </select>
    //         )}
    //       </div> */}

    //       {/* Sync Button */}
    //       {/* <button
    //         onClick={syncWithGoogleSheets}
    //         disabled={syncing}
    //         className="p-2 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors flex items-center gap-2 text-xs font-bold border border-white/20 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
    //       >
    //         <span>🔄</span> <span className="hidden xl:inline">Sync Data</span>
    //       </button> */}

    //       {/* Role text */}
    //       {/* <div className="text-right hidden xl:block">
    //         <p className="text-sm font-semibold text-white">Administrator</p>
    //         <p className="text-xs text-white opacity-75">School Principal</p>
    //       </div> */}

    //       {/* User Avatar */}
    //       {/* <div
    //         className="w-10 h-10 rounded-full flex items-center justify-center text-white text-lg font-bold shadow-md shrink-0 select-none"
    //         style={{ backgroundColor: '#ff751f' }}
    //       >
    //         👤
    //       </div>

    //       <button
    //         onClick={logout}
    //         title="Log out"
    //         className="p-2 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors text-sm border border-white/20 cursor-pointer"
    //       >
    //         🚪
    //       </button>*/}
    //     </div> 
    //   </div>
    // </header>
  );
};
export default Header;
